// client/src/components/admin/TransactionsManagement.js
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';

const TransactionsManagement = () => {
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  
  useEffect(() => {
    const fetchTransactions = async () => {
      try {
        // In a real implementation, this would be a dedicated API endpoint
        // For now, we'll just use sample data
        const mockTransactions = [
          {
            id: '1',
            type: 'allocation',
            amount: 2000000,
            request: { requestId: '1087', company: { name: 'FinTech Italia' } },
            fromOrganization: { name: 'Unicredit' },
            toOrganization: { name: 'FinTech Italia' },
            status: 'completed',
            transactionDate: new Date(new Date().setDate(new Date().getDate() - 14))
          },
          {
            id: '2',
            type: 'allocation',
            amount: 2200000,
            request: { requestId: '1087', company: { name: 'FinTech Italia' } },
            fromOrganization: { name: 'Banco BPM' },
            toOrganization: { name: 'FinTech Italia' },
            status: 'completed',
            transactionDate: new Date(new Date().setDate(new Date().getDate() - 14))
          }
        ];
        
        setTransactions(mockTransactions);
        setLoading(false);
      } catch (err) {
        setError('Failed to fetch transactions');
        setLoading(false);
      }
    };
    
    fetchTransactions();
  }, []);
  
  if (loading) {
    return <div className="loading">Loading transactions...</div>;
  }
  
  if (error) {
    return <div className="error-message">{error}</div>;
  }
  
  return (
    <div className="transactions-management">
      <h2>Transaction Management</h2>
      
      <div className="card">
        <div className="card-title">
          <span>All Transactions</span>
        </div>
        <table>
          <thead>
            <tr>
              <th>Transaction ID</th>
              <th>Type</th>
              <th>Amount</th>
              <th>From</th>
              <th>To</th>
              <th>Request</th>
              <th>Date</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {transactions.length > 0 ? (
              transactions.map(transaction => (
                <tr key={transaction.id}>
                  <td>#{transaction.id}</td>
                  <td>{transaction.type === 'allocation' ? 'Allocation' : transaction.type}</td>
                  <td>€{transaction.amount.toLocaleString()}</td>
                  <td>{transaction.fromOrganization.name}</td>
                  <td>{transaction.toOrganization.name}</td>
                  <td>#{transaction.request.requestId}</td>
                  <td>{transaction.transactionDate.toLocaleDateString()}</td>
                  <td>
                    <span className={`status status-${transaction.status === 'completed' ? 'approved' : 'pending'}`}>
                      {transaction.status}
                    </span>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="8">No transactions found</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TransactionsManagement;
